import {useMemo} from 'react';
import {
  RadioGroupField,
  ActionType,
  SelectOption,
  Option,
} from '../../../../components/AutoForm/AutoFieldNew';
import {recommendFieldsType} from '../recommendFields';
import {OVRecommendActionEnum} from '../../../../schema-types/globalTypes';
import {POTS_BOND, POTS_GIA, POTS_PENSION} from '../../../../utils/potsFilter';
import {AccountBasicFragment} from '../../../../schema-types/AccountBasicFragment';

export const useRecommendPlanOptionsField = ({
  planTypes,
  selectedLabel,
  isSubmitting,
  values,
  account,
}: {
  planTypes: Option<string>[];
  selectedLabel: string;
  isSubmitting: boolean;
  values: recommendFieldsType;
  account: AccountBasicFragment | undefined;
}): RadioGroupField => {
  const field: RadioGroupField = useMemo(() => {
    const options: SelectOption[] = planTypes
      .filter((plan) => {
        if (values.how === 'Instruction') {
          if (plan.value.includes('protection')) {
            return false;
          }
        }
        // Corporate accounts are treated as trusts by oneView
        // I'm putting this check outside of the isTrust scope
        // in case we change this behaviour in the future
        if (account?.accountType === 'Corporate' && plan.value === POTS_PENSION) {
          return true;
        }
        if (account?.isTrust) {
          if (plan.value === POTS_BOND || plan.value === POTS_GIA) {
            return true;
          }
          return false;
        }
        if (values.planAction === OVRecommendActionEnum.TRANSFER) {
          if (plan.value.includes('bond')) {
            return false;
          }
        }
        return true;
      })
      .map((plan) => {
        return {
          value: plan.value,
          label: plan.label,
        };
      });

    return {
      id: 'mainPlanType',
      label: selectedLabel,
      boldLabel: true,
      type: ActionType.radioGroup,
      options,
      disabled: isSubmitting,
    };
  }, [values.how, values.planAction, selectedLabel, planTypes, isSubmitting, account]);

  return field;
};
